import {
  BuyButton,
  CardInfoRow,
  DotsButton,
  ImgWrapper,
  LikeWrapper,
  NftCardInfo,
  NftCardLogo,
  NftCardWrapper,
  NftPrice,
  NftTitle,
} from "./NftCard.styled";
import ton_logo from "../../../assets/img/ton-logo.svg";
import { useState } from "react";
import { DotsDropdown } from "./DotsDropdown/DotsDropdown";
import { LikeHeart } from "../../../assets/img/LikeHeart";

export const NftCard = ({ product }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [like, setLike] = useState(false);
  return (
    <NftCardWrapper
      to={`/marketplace/nfts/${product.id}`}
      onMouseEnter={() => {
        setShowButton(true);
      }}
      onMouseLeave={() => {
        setShowButton(false);
        setShowDropdown(false);
      }}>
      <ImgWrapper>
        <LikeWrapper
          onClick={(e) => {
            e.preventDefault();
            setLike(!like);
          }}>
          {LikeHeart(like)}
        </LikeWrapper>
        <img src={product?.img} alt='nft' />
      </ImgWrapper>
      <NftCardInfo>
        {showDropdown && <DotsDropdown collection={product?.collection} creator={product?.creator} owner={product?.owner} />}
        <CardInfoRow>
          <NftTitle>{product?.title}</NftTitle>
          <DotsButton
            onClick={(e) => {
              e.preventDefault();
              setShowDropdown(true);
            }}>
            <span></span>
            <span></span>
            <span></span>
          </DotsButton>
        </CardInfoRow>
        <CardInfoRow>
          <NftPrice>
            <span>Current price:</span>
            <h5>{product?.price} TON</h5>
          </NftPrice>
          <NftCardLogo src={ton_logo} alt='ton logo' />
        </CardInfoRow>
        <CardInfoRow>
          <BuyButton showButton={showButton}>Buy Now</BuyButton>
        </CardInfoRow>
      </NftCardInfo>
    </NftCardWrapper>
  );
};
